import React from 'react'

const ChatIcon = ({ className, size = 40, currentColor = "#4F46E5" }) => {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         className={className}
         width={size}
         height={size}
         viewBox={`0 0 ${size} ${size}`}
         fill={currentColor}>
         <path d="M6.66732 29.9987C5.75065 29.9987 4.96593 29.6723 4.31315 29.0195C3.66037 28.3668 3.33398 27.582 3.33398 26.6654V6.66536C3.33398 5.7487 3.66037 4.96398 4.31315 4.3112C4.96593 3.65842 5.75065 3.33203 6.66732 3.33203H33.334C34.2507 3.33203 35.0354 3.65842 35.6882 4.3112C36.3409 4.96398 36.6673 5.7487 36.6673 6.66536V26.6654C36.6673 27.582 36.3409 28.3668 35.6882 29.0195C35.0354 29.6723 34.2507 29.9987 33.334 29.9987H24.459L21.3757 34.582C21.209 34.832 21.0076 35.0195 20.7715 35.1445C20.5354 35.2695 20.2784 35.332 20.0007 35.332C19.7229 35.332 19.4659 35.2695 19.2298 35.1445C18.9937 35.0195 18.7923 34.832 18.6257 34.582L15.5423 29.9987H6.66732ZM20.0007 30.6654L22.6673 26.6654H33.334V6.66536H6.66732V26.6654H17.334L20.0007 30.6654Z" fill={currentColor}/>
      </svg>
   )
}

export default ChatIcon
